








































































































import Vue from 'vue';
import allWords from '@/lib/wordlists';
import PlaylistClass from '@/lib/playlist';
import HomeFab from '@/components/HomeFab.vue';
import Playlist from '@/components/Playlist.vue';

export default Vue.extend({
  name: 'Import',
  components: {
    HomeFab,
    Playlist,
  },
  data() {
    return {
      playlistLinkOrId: '',
      search: '',
      fetchError: '',
      playlists: [] as PlaylistClass[],
      playlistIdToIndex: {} as { [id: string]: number },
      openedPlaylist: 0,
    };
  },
  computed: {
    parsedPlaylistId(): string | null {
      return PlaylistClass.parseId(this.playlistLinkOrId);
    },
  },
  created() {
    this.playlists = Object.values(this.$store.state.customWords)
      .filter((list: any) => list.key.startsWith('bomb/'))
      .map(
        (list, index) => {
          const { key, name, items } = list as { key: string; name: string; items: string[] };
          const newPlaylist = new PlaylistClass(key.slice(5));
          newPlaylist.name = name;
          newPlaylist.songs = items.map(
            (s, id) => {
              const [author, title] = s.split(';', 2);
              return {
                id,
                author,
                title,
                alts: [
                  { author, title, confidence: 100 },
                  { author: title, title: author, confidence: 0 },
                ],
              };
            },
          );
          this.playlistIdToIndex[newPlaylist.id] = index;
          return newPlaylist;
        },
      );
  },
  watch: {
    playlists: {
      handler() {
        this.playlists.forEach((playlist) => {
          this.$store.commit('insertCustomWordlist', playlist.toJSON());
        });
      },
      deep: true,
    },
  },
  methods: {
    deletePlaylist(index: number) {
      const { key } = this.playlists[index].toJSON();
      this.playlists.splice(index, 1);
      this.playlistIdToIndex = {};
      this.openedPlaylist = -1;
      this.playlists.forEach(({ id }, idx) => {
        this.playlistIdToIndex[id] = idx;
      });
      this.$store.commit('removeCustomWordlist', key);
    },
    savePlaylist() {
      if (this.parsedPlaylistId === null) {
        return;
      }
      this.fetchError = '';
      const newPlaylist = new PlaylistClass(this.parsedPlaylistId);
      newPlaylist.fetch().then((playlist) => {
        this.playlistLinkOrId = '';
        if (newPlaylist.id in this.playlistIdToIndex) {
          const index = this.playlistIdToIndex[newPlaylist.id];
          this.playlists[index] = newPlaylist;
          this.openedPlaylist = index + 1;
        } else {
          this.playlistIdToIndex[newPlaylist.id] = this.playlists.length;
          this.playlists.push(newPlaylist);
          this.openedPlaylist = this.playlists.length;
        }
        const result = playlist.toJSON();
        if (result.key in this.$store.state.customWords) {
          const tree = allWords.findSubtree(result.key);
          tree.numWords -= tree.wordList.length;
          tree.wordList = [];
        }
        allWords.insertNode(result.key, result.items).name = result.name;
        this.$store.commit('insertSelectedWordlists', `/root/${result.key}`);
      }).catch((err) => { this.fetchError = err.toString(); });
    },
  },
});
